// extracted by css-extract-rspack-plugin
export default {"container":"sYsQfOtakRY8x5Mq","actions":"dYgRXjkTt7svV6AX"};